// 公开头像:上传前在手机上裁成正方形、缩到 512px 并用 canvas 重新编码
// (重编码会去掉 EXIF/GPS 等元数据,服务端也会拒收带 EXIF 的图片)。头像与脸纹分开存放,不参与识别。
const JIC_URL = "https://u.jic.io";
const SIZE = 512;

function loadImage(file: File): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const image = new Image();
    image.onload = () => {
      URL.revokeObjectURL(url);
      resolve(image);
    };
    image.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error("图片打不开，换一张"));
    };
    image.src = url;
  });
}

function toBlob(canvas: HTMLCanvasElement, type: string, quality: number): Promise<Blob | null> {
  return new Promise((resolve) => canvas.toBlob(resolve, type, quality));
}

export async function prepareAvatar(file: File): Promise<Blob> {
  const image = await loadImage(file);
  const side = Math.min(image.naturalWidth, image.naturalHeight);
  if (!side) throw new Error("图片尺寸不对");
  const canvas = document.createElement("canvas");
  canvas.width = SIZE;
  canvas.height = SIZE;
  const context = canvas.getContext("2d");
  if (!context) throw new Error("浏览器不支持图片处理");
  context.drawImage(
    image,
    (image.naturalWidth - side) / 2,
    (image.naturalHeight - side) / 2,
    side,
    side,
    0,
    0,
    SIZE,
    SIZE
  );
  // 部分 Safari 不能编码 webp,会退回 png;此时改用 jpeg
  const webp = await toBlob(canvas, "image/webp", 0.86);
  if (webp && webp.type === "image/webp") return webp;
  const jpeg = await toBlob(canvas, "image/jpeg", 0.88);
  if (!jpeg) throw new Error("图片压缩失败");
  return jpeg;
}

export async function uploadAvatar(blob: Blob, jwt: string): Promise<{ ok: boolean; avatar?: string; error?: string }> {
  const response = await fetch(`${JIC_URL}/v1/avatar`, {
    method: "POST",
    headers: { "Content-Type": blob.type, Authorization: `Bearer ${jwt}` },
    body: blob,
  });
  return (await response.json().catch(() => ({ ok: false, error: `上传失败 (${response.status})` }))) as {
    ok: boolean;
    avatar?: string;
    error?: string;
  };
}

export async function deleteAvatar(jwt: string): Promise<{ ok: boolean; error?: string }> {
  const response = await fetch(`${JIC_URL}/v1/avatar`, {
    method: "DELETE",
    headers: { Authorization: `Bearer ${jwt}` },
  });
  return (await response.json()) as { ok: boolean; error?: string };
}
